<template>
    <section class="generalContainer farmerContainer">
        <div class="container">
            <div class="offset-lg-1 col-lg-10 shippingContainer margin_top_xl">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="shippingContainer__details">
                            <h4 class="font-bold margin_bottom_md">Order #{{orderNumber}}</h4>
                            <div class="row my-3">
                                <div class="col-4 color__grey_light">Order Total:</div>
                                <div class="col-8"><span class="naira"></span> {{orderTotal | formatNumber }}</div>
                            </div>
                            <div class="row my-3">
                                <div class="col-4 color__grey_light">Order Date:</div>
                                <div class="col-8">{{order ? moment(order.created_at).format('ddd, DD MMM. YYYY') : '**'}}</div>
                            </div>
                            <div class="row my-3">
                                <div class="col-4 color__grey_light">Order Number:</div>
                                <div class="col-8">{{orderNumber}}</div>
                            </div>
                            <!-- <div class="row my-4">
                                <div class="col-4 color__grey_light">Est. Delivery:</div>
                                <div class="col-8"> 
                                    {{offer ? moment(offer.crop.harvest_date).format('ddd, DD MMM. YYYY') : '**'}}</div>
                            </div> -->
                            <div class="row my-3">
                                <div class="col-4 color__grey_light">Shipping:</div>
                                <div class="col-8" v-if="addresses.length !== 0">
                                    <h4 class="font-bold font-sm mb-3 mt-2">{{addresses[0].full_name}}</h4>
                                    <p class="">{{addresses[0].address}},{{addresses[0].city}}, {{addresses[0].state.name}}, Nigeria</p>
                                    <p class="">{{addresses[0].email}}</p>
                                    <p>{{addresses[0].phone_no}}</p>
                                </div>
                            </div>
                            <div class="row my-3">
                                <div class="col-4 color__grey_light">Order Status:</div>
                                <div class="col-8" :class="checkStatusColor">{{order.status}}</div>
                            </div>
                            <div class="row my-3" v-if="order && (order.status === 'pending' || order.status === 'awaiting_payment')">
                                <div class="col-4"></div>
                                <div class="col-8">
                                    <router-link :to="{ name: 'offtaker.orderpayment', params: { id: order.id }}" class="btn btn-sm btn-secondary" href="#">
                                        Complete Payment
                                    </router-link>
                                </div>
                            </div>
                            <!-- <div class="row my-3">
                                <div class="col-4 color__grey_light pr-0">Payment method:</div>
                                <div class="col-8">Visa - 4534 XXXX XXXX XXXX</div>
                            </div> -->

                        </div>

                        <div class="shippingContainer__summary margin_top_md">
                            <h4 class="margin_bottom_md font-md font-bold">Item(s)</h4>

                            <div v-for="(item, index) in items" :key="index">
                                <div class="row">
                                    <div class="col-4 col-lg-3">
                                        <div class="shippingContainer__summary__img">
                                            <img :src="item.crop.crop.image_url" v-if="item.crop.crop && item.crop.crop.image_url !== null" />
                                            <svg width="42" height="42" viewBox="0 0 32 32" fill="none" v-else style="width: 100%; height: 100%"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <rect width="32" height="32" rx="11" fill="#726E0B" fill-opacity="0.25" />
                                                <g clip-path="url(#clip0)">
                                                    <path
                                                        d="M20.0763 18.2944C19.9342 18.1523 19.7237 18.1131 19.54 18.1947C18.3702 18.714 17.6571 19.0974 17.4205 19.3342C17.1848 19.5698 17.0399 19.8719 17.0127 20.185C16.9952 20.3852 17.0288 20.5799 17.1065 20.7516L16.3623 21.4948V18.892H16.3622L17.618 17.6379C17.7614 17.7026 17.9187 17.7346 18.0796 17.7346C18.4145 17.7346 18.7647 17.5958 19.0364 17.3242C19.2731 17.0877 19.6566 16.3746 20.176 15.2046C20.2575 15.0209 20.2184 14.8103 20.0762 14.6682C19.934 14.5261 19.7235 14.487 19.5399 14.5686C18.3701 15.0878 17.657 15.4712 17.4204 15.7081C17.1846 15.9436 17.0399 16.2457 17.0126 16.5588C16.9951 16.759 17.0286 16.9537 17.1064 17.1254L16.3621 17.8686V15.3165L17.6179 14.0627C17.7613 14.1274 17.9186 14.1595 18.0795 14.1595C18.4144 14.1595 18.7647 14.0206 19.0363 13.7487C19.2731 13.5122 19.6565 12.7991 20.1759 11.6291C20.2575 11.4454 20.2183 11.2348 20.0762 11.0927C19.934 10.9506 19.7234 10.9115 19.5398 10.9931C18.37 11.5123 17.657 11.8957 17.4204 12.1326C17.1846 12.3681 17.0398 12.6703 17.0125 12.9835C16.9951 13.1838 17.0286 13.3785 17.1063 13.5502L16.3621 14.2933V11.8376C16.8152 11.6661 17.1428 11.1822 17.1428 10.6132C17.1428 10.2776 16.9096 9.50231 16.4498 8.30884C16.3776 8.12122 16.2011 8 16.0001 8C15.7991 8 15.6225 8.12122 15.5503 8.30875C15.0905 9.50228 14.8574 10.2776 14.8574 10.6132C14.8574 11.1822 15.1849 11.666 15.638 11.8376V14.2932L14.8938 13.5502C14.9715 13.3785 15.005 13.1837 14.9876 12.9835C14.9603 12.6703 14.8155 12.3681 14.5797 12.1325C14.3431 11.8957 13.63 11.5123 12.4604 10.9931C12.2767 10.9115 12.0661 10.9506 11.924 11.0927C11.7819 11.2348 11.7427 11.4454 11.8243 11.6291C12.3437 12.799 12.7271 13.5122 12.9636 13.7483C13.2354 14.0204 13.5857 14.1594 13.9208 14.1594C14.0816 14.1594 14.2389 14.1273 14.3822 14.0627L15.6381 15.3165V17.8685L14.8939 17.1254C14.9715 16.9537 15.0051 16.759 14.9877 16.5587C14.9604 16.2457 14.8156 15.9436 14.5799 15.708C14.3432 15.4712 13.6302 15.0877 12.4604 14.5685C12.2768 14.4869 12.0662 14.526 11.9241 14.6682C11.7819 14.8103 11.7427 15.0208 11.8243 15.2045C12.3437 16.3745 12.7272 17.0876 12.9638 17.3239C13.2356 17.5957 13.5857 17.7345 13.9207 17.7345C14.0815 17.7345 14.2388 17.7024 14.3822 17.6377L15.6381 18.8919V21.4947L14.894 20.7516C14.9716 20.5799 15.0051 20.3852 14.9877 20.185C14.9605 19.8719 14.8156 19.5697 14.5799 19.3342C14.3433 19.0973 13.6302 18.714 12.4605 18.1947C12.2769 18.1132 12.0663 18.1523 11.9241 18.2944C11.782 18.4365 11.7428 18.647 11.8244 18.8308C12.3438 20.0008 12.7272 20.7138 12.9637 20.95C13.1994 21.1859 13.5016 21.3308 13.8148 21.358C13.8495 21.361 13.8841 21.3625 13.9184 21.3625C14.0822 21.3625 14.2401 21.3285 14.3823 21.264L15.6382 22.5182V23.2757H13.6703C13.4703 23.2757 13.3082 23.4378 13.3082 23.6378C13.3082 23.8378 13.4703 23.9999 13.6703 23.9999H17.2253C17.4252 23.9999 17.5873 23.8378 17.5873 23.6378C17.5873 23.4378 17.4252 23.2757 17.2253 23.2757H16.3623V22.5182L17.6182 21.264C17.7603 21.3284 17.9183 21.3625 18.0821 21.3625C18.1164 21.3625 18.151 21.361 18.1857 21.358C18.4989 21.3308 18.8012 21.1859 19.0365 20.9503C19.2733 20.7139 19.6567 20.0007 20.1761 18.8308C20.2576 18.6471 20.2185 18.4365 20.0763 18.2944ZM17.734 16.6216C17.7464 16.4801 17.8187 16.3338 17.9324 16.2202C17.9325 16.2201 17.9326 16.22 17.9327 16.2199C18.0317 16.1208 18.4343 15.8792 19.2464 15.4982C18.8652 16.3103 18.6237 16.7128 18.5245 16.812C18.3071 17.0293 17.9877 17.0773 17.8272 16.917C17.8272 16.917 17.8272 16.917 17.8272 16.917C17.732 16.8218 17.728 16.6911 17.734 16.6216ZM17.734 13.0463C17.7464 12.9046 17.8187 12.7582 17.9324 12.6446C17.9325 12.6445 17.9326 12.6444 17.9327 12.6443C18.0317 12.5452 18.4344 12.3037 19.2464 11.9226C18.8652 12.7348 18.6237 13.1374 18.5244 13.2366C18.3071 13.454 17.9877 13.5022 17.8272 13.3418C17.732 13.2467 17.728 13.1158 17.734 13.0463ZM14.1732 13.3416C14.0124 13.5022 13.6931 13.454 13.4756 13.2362C13.3765 13.1373 13.135 12.7347 12.7538 11.9226C13.566 12.3037 13.9685 12.5452 14.0675 12.6443C14.0675 12.6444 14.0677 12.6445 14.0678 12.6446C14.1815 12.7582 14.2538 12.9046 14.2661 13.0462C14.2722 13.1158 14.2682 13.2467 14.1732 13.3416ZM14.1732 16.9168C14.0125 17.0773 13.693 17.0293 13.4755 16.8118C13.3765 16.7128 13.135 16.3102 12.7538 15.4982C13.5659 15.8793 13.9685 16.1208 14.0674 16.2199C14.0675 16.22 14.0676 16.2201 14.0677 16.2202C14.1815 16.3338 14.2538 16.4801 14.2661 16.6216C14.2722 16.6911 14.2681 16.8218 14.1732 16.9168ZM14.1731 20.5431C14.173 20.5432 14.1729 20.5432 14.1728 20.5433C14.1728 20.5433 14.1727 20.5434 14.1727 20.5434C14.0775 20.6385 13.9469 20.6427 13.8773 20.6366C13.7358 20.6243 13.5895 20.552 13.4756 20.438C13.3765 20.339 13.135 19.9364 12.7538 19.1243C13.566 19.5054 13.9685 19.7469 14.0675 19.846C14.0675 19.8461 14.0677 19.8462 14.0678 19.8463C14.1815 19.9599 14.2538 20.1063 14.2661 20.2478C14.2722 20.3172 14.2681 20.4479 14.1731 20.5431ZM16.0001 11.1802C15.7732 11.1802 15.5815 10.9206 15.5815 10.6132C15.5815 10.4726 15.6955 10.0166 16.0001 9.1735C16.3047 10.0167 16.4186 10.4726 16.4186 10.6132C16.4186 10.9206 16.227 11.1802 16.0001 11.1802ZM18.5244 20.4383C18.4107 20.5521 18.2644 20.6243 18.1229 20.6367C18.0533 20.6427 17.9225 20.6386 17.8272 20.5432C17.732 20.4481 17.728 20.3173 17.734 20.2479C17.7464 20.1064 17.8187 19.96 17.9324 19.8464C17.9325 19.8463 17.9326 19.8462 17.9327 19.8461C18.0317 19.747 18.4343 19.5055 19.2464 19.1244C18.8652 19.9365 18.6237 20.3391 18.5244 20.4383Z"
                                                        fill="#565009" />
                                                    <path
                                                        d="M18.3297 23.2758H18.2205C18.0206 23.2758 17.8584 23.4379 17.8584 23.6379C17.8584 23.8379 18.0205 24 18.2205 24H18.3297C18.5297 24 18.6918 23.8379 18.6918 23.6379C18.6918 23.4379 18.5297 23.2758 18.3297 23.2758Z"
                                                        fill="#565009" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col-8 col-lg-9 d-flex justify-content-center flex-column">
                                        <h4 class="font-bold font-sm mb-2"><span class="naira"></span> 
                                            {{ (item.quantity * item.crop.kg_price) + ((item.quantity * item.crop.kg_price) * 0.05) | formatNumber }}
                                        </h4>
                                        <h4><span class="font-bold font-sm">{{item.crop.name}}</span></h4>
                                        <!-- <p class="mt-2 mb-0">By <span class="color__primary">{{item.crop.farm.farmer_name}}</span></p> -->
                                        <p>Qty: {{ item.quantity / 1000 | formatNumber}} ton(s)</p>
                                    </div>
                                </div>
                                <div class="divider"></div>
                            </div>
                            
                            <!-- <div class="mb-2">
                                <a href="#">Cancel Order</a>
                            </div> -->
                            <div class="mb-2">
                                <router-link :to="{ name: 'offtaker.dashboard'}" >My Dashboard</router-link>
                            </div>
                            <div class="mb-2">
                                <router-link :to="{ name: 'offtaker.profile'}" >My Account</router-link>
                            </div>
                            <div>
                                <router-link href="#" :to="{name: 'offtaker.mycrops'}">My Crops</router-link>
                            </div>
                        </div>

                        <div class="margin_top_md margin_bottom_lg">
                            <router-link :to="{ name: 'offtaker.mycrops'}" class="btn btn-primary-outline col-12">Continue Shopping</router-link>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="shippingContainer__deals">
                            <div class="shippingContainer__deals__contact">
                                <h4 class="font-bold font-md margin_bottom_md">Trouble with your order?</h4>
                                <p>Contact our support team , and tell us about your troubles. we are hear to make your job easier.</p>
                                <submit-button class="btn btn-white mt-4 col-12">Contact Support</submit-button>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
    </section>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            moment,
            loadingOrder: false,
            loadingOffer: false,
            loadingAddress: false,
            order: '',
            addresses: [],
            items: []
        }
    },
    computed: {
        orderId() {
            return this.$route.params.id
        },
        orderNumber() {
            if(this.order) {
                const index = this.order.reference.lastIndexOf('-');
                return this.order.reference.slice(index+1);
            }
            return '***';
        },
        checkStatus() {
            if(this.order) {
                if(this.order.verified_at == null) {
                    return 'Awaiting payment'
                } else {
                        switch (this.order.status) {
                        case 'pending':
                            return 'Awaiting confirmation';
                        case 'accepted':
                            return 'Awaiting confirmation';
                        case 'completed':
                            return 'Completed';
                        case 'cancelled':
                            return 'Cancelled'
                        default:
                            return '';
                    }
                } 
            } else {
                return ''
            }
            
        },
        checkStatusColor() {
            if(this.order) {
                switch (this.order.status) {
                    case 'pending':
                        return 'color__grey'
                    case 'shipped':
                        return 'color__green';
                    case 'delivered':
                        return 'color__primary'
                    case 'awaiting_payment':
                        return 'color__secondary' 
                    case 'cancelled':
                        return 'color__grey_light'
                    default:
                        return ''
                } 
            } else {
                return ''
            }
            
        },
        orderTotal() {
            if(this.order) {
                return Number(this.order.total_amount) + Number(this.order.tax_amount)
            }
            return ''
        },
        cropUrl() {
            return this.order && this.order.crop && this.order.crop.crop.image_url && this.order.crop.crop.image_url !== null ? 
            this.order.crop.crop.image_url : ''
        }
    },
    methods: {
        
        getOrder() {
            this.loadingOrder = true;
            this.$http.get(`crop_orders/${this.orderId}`)
            .then((response) => {
                this.order = response.data
                this.items = this.order.items
                this.$log(response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.loadingOrder = false;
            })
        },
        getAddress() {
            this.loadingAddress = true;
            this.$http.get('addresses')
            .then((response) => {
                this.addresses = response.data
                this.$log(response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.loadingAddress = false;
            })
        },
        
    },
    created() {
        this.getOrder();
        this.getAddress();
    }
}
</script>

<style>

</style>